<template>
  <PopupUI
    v-if="isOpen && componentName"
    :small="true"
    :no-inner-indent="true"
    :prevent-close-event="preventClosePopup"
    class="auth-ui"
    @on-close="hideAuth"
  >
    <component
      :is="componentName"
      v-if="componentName"
      :type-auth="typeAuth"

      :from="from"
      :back="back"

      :phone="phone"
      :code="code"

      :code-phone="codePhone"
      :number-phone="numberPhone"
      :country-id="countryId"
      :location-id="locationId"
      :country-code="countryCode"

      :short-form-specialist="shortFormSpecialist"
      :key-short-form="keyShortForm"

      :hide-link-type-auth="hideLinkTypeAuth"
      :callback="callback"

      :subtitle="subtitle"

      @set-action="setAction"
    />
  </PopupUI>
</template>

<script>
import {
  sendEventYM,
  sendUserIdYM,
  TYPE_DIRECTORY
} from '../../../utils/common';
import { AVAILABLE_FROM_PARAMETERS } from '../../../utils/auth';
import { parseConfig } from '../../../../utils/json-config';

export default {
  name: 'SpecialistAuth',

  components: {
    PopupUI           : () => import('../common/PopupUI'),
    LoginAuth         : () => import('./components/LoginAuth.vue'),
    RegistrationAuth  : () => import('./components/RegistrationAuth.vue'),
    SmsVerifyAuth     : () => import('./components/SmsVerifyAuth.vue'),
    CreateAccountAuth : () => import('./components/CreateAccountAuth.vue'),

    RestorePasswordAuth        : () => import('./components/RestorePasswordAuth.vue'),
    RequestRestorePasswordAuth : () => import('./components/RequestRestorePasswordAuth.vue'),
    SuccessRestorePasswordAuth : () => import('./components/SuccessRestorePasswordAuth.vue')
  },

  props: {
    defaultTypeAuth: {
      type    : String,
      default : null
    }
  },

  data() {
    return {
      typeAuth      : TYPE_DIRECTORY.specialist.value,
      isOpen        : null,
      componentName : null,

      back  : null,
      from  : null,
      phone : null,
      code  : null,

      codePhone   : null,
      numberPhone : null,
      countryId   : null,
      locationId  : null,
      countryCode : null,

      shortFormSpecialist : null,
      keyShortForm        : null,

      hideLinkTypeAuth  : false,
      preventClosePopup : false,
      goToPage          : null,
      callback          : null,

      subtitle: null
    };
  },

  created() {
    document.addEventListener('auth:show', (event) => this.showLoginAuth(event));
    document.addEventListener('auth:reg', (event) => this.showRegistration(event));
    document.addEventListener('auth:hide', () => this.hideAuth());
    document.addEventListener('auth:createAccount', (event) => this.showCreateAccount(event));

    document.addEventListener('auth:showRestorePassword', () => this.showRestorePassword());
    document.addEventListener('auth:showRequestRestorePassword', (event) => this.showRequestRestorePassword(event));
    document.addEventListener('auth:successRestorePassword', () => this.showSuccessRestorePassword());

    document.addEventListener('auth:showSmsVerify', (event) => this.showSmsVerify(event));

    this.setFromAuth({});
  },

  methods: {
    setFromAuth(event) {
      let from = event.detail && event.detail.from ? event.detail.from : null;

      // ! ALCSUP21-5237 временное решение
      const pageConfig = parseConfig('page-setup-data');
      if ('fromCode' in pageConfig) {
        from = pageConfig.fromCode;
      }

      if (!AVAILABLE_FROM_PARAMETERS.includes(from)) {
        // eslint-disable-next-line prefer-destructuring
        from = AVAILABLE_FROM_PARAMETERS[0];
      }

      /**
       * Показывает откуда открывается форма входа и регистрации
       * @var {string}
       */
      this.from = from;
    },

    setBackAuth(event) {
      this.back = event.detail && event.detail.back ? event.detail.back : null;
    },

    setParams(params) {
      if (params.phone) {
        this.phone = params.phone;
      }
      if (params.countryId) {
        this.countryId = params.countryId;
      }
      if (params.locationId) {
        this.locationId = params.locationId;
      }
      if (params.code) {
        this.code = params.code;
      }
      if (params.codePhone) {
        this.codePhone = params.codePhone;
      }
      if (params.numberPhone) {
        this.numberPhone = params.numberPhone;
      }
      if (params.countryCode) {
        this.countryCode = params.countryCode;
      }
      if (params.shortFormSpecialist) {
        this.shortFormSpecialist = params.shortFormSpecialist;
      }
      if (params.key) {
        this.keyShortForm = params.key;
      }
      if (params.hideLinkTypeAuth) {
        this.hideLinkTypeAuth = params.hideLinkTypeAuth;
      }
      if (params.preventClosePopup) {
        this.preventClosePopup = params.preventClosePopup;
      }
      if (params.goToPage) {
        this.goToPage = params.goToPage;
      }
      if (params.callback) {
        this.callback = params.callback;
      }
      if (params.subtitle) {
        this.subtitle = params.subtitle;
      }
    },

    hideAuth() {
      this.isOpen = false;
      this.componentName = null;

      this.$emit('hide-auth', this.typeAuth);
    },

    showLoginAuth(event) {
      this.setFromAuth(event);
      this.setBackAuth(event);

      if (event.detail) {
        this.setParams(event.detail);
      }

      // Отображаем форму входа
      this.isOpen = true;
      this.componentName = 'login-auth';
    },

    showRegistration(event) {
      this.setFromAuth(event);
      this.setBackAuth(event);

      if (event.detail) {
        this.setParams(event.detail);
      }

      this.isOpen = true;
      this.componentName = 'registration-auth';
    },

    showSmsVerify(event) {
      this.isOpen = true;

      if (event.detail) {
        this.setParams(event.detail);
      }

      this.setBackAuth(event);
      this.componentName = 'sms-verify-auth';
    },

    showCreateAccount(event) {
      this.isOpen = true;

      if (event.detail) {
        this.setParams(event.detail);
      }

      this.componentName = 'create-account-auth';
    },

    showRestorePassword() {
      this.isOpen = true;
      this.componentName = 'restore-password-auth';
    },

    showRequestRestorePassword(event) {
      if (event) {
        this.setBackAuth(event);
      }

      this.isOpen = true;
      this.componentName = 'request-restore-password-auth';
    },

    showSuccessRestorePassword() {
      this.isOpen = true;
      this.componentName = 'success-restore-password-auth';
    },

    setAction(data) {
      this.setYMForAction(data && data.action ? data.action : null);

      if (data && data.params) {
        this.setParams(data.params);
      }

      if (data && data.action === 'specialist_authorizing_verified') {
        document.dispatchEvent(new CustomEvent('auth:createAccount'));
      }
      if (data && data.action === 'specialist_short_authorizing_verified') {
        document.dispatchEvent(new CustomEvent('auth:createAccount', {
          detail: {
            shortFormSpecialist : true,
            key                 : data && data.key ? data.key : null
          }
        }));
      }
      if ((data && data.action === 'specialist_authorized') || (data && data.action === 'specialist_registered')) {
        // Если есть userId - отправляем метрику
        if (data.userId) {
          sendUserIdYM(data.userId);
        }

        const searchParams = new URLSearchParams(window.location.search);

        if (this.goToPage) {
          window.location.href = this.goToPage;
        } else if (this.callback && typeof this.callback === 'function') {
          this.hideAuth();
          this.callback(data.action);
        } else if (searchParams.has('auth') || searchParams.has('reg')) {
          window.location.reload();
        } else {
          window.location.reload();
        }
      }
    },
    setYMForAction(action) {
      if (!action) return;

      if (action === 'specialist_authorized') {
        sendEventYM('login');
      }

      if (action === 'specialist_registered') {
        sendEventYM('registration_done');
      }
    }
  }
};
</script>
